import React from 'react';
import { isLifetimePlan } from '../../../utils/planUtils';
import { styled } from '@material-ui/core';

const KidSafeWrapper = styled('div')({
    textAlign: 'center',
    '& ul': {
        textAlign: 'left',
    },
});

export default function KidsSafeDisclaimer({ offer, className='secure-claim' }) {
    const LIFETIME_TEXT = 'Lifetime subscribers’ data is retained indefinitely. Parents may delete all account data at any time in the parent portal settings in the app.';
    const DEFAULT_TEXT = 'To ensure your data privacy, we may periodically delete data after a prolonged period of account inactivity. Parents may delete all account data at any time in the parent portal settings in the app.';
    const bulletText = isLifetimePlan(offer) ? LIFETIME_TEXT : DEFAULT_TEXT;

    return (
        <KidSafeWrapper className={className}>
            <ul>
                <li>Users of codeSpark may receive push notification alerting them to in-app activity and new features once their subscription is active. You may disable push notifications by changing the device’s notification settings for codeSpark.</li>
                <li>The story creation tool enables users to record voice, upload photos, and type speech bubbles. Users can share their stories in the moderated community with other users. Users can share links to projects once free trial ends and payment is made. Parents may turn off this feature in the parent portal settings in the app.</li>
                <li>{bulletText}</li>
            </ul>
            <span className="legal-wrapper"><a target="_blank" href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/terms`} rel="noopener noreferrer">Terms of Service </a> | <a target="_blank" href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/privacy`} rel="noopener noreferrer">Privacy Policy</a>.</span>
        </KidSafeWrapper>
    )
}
